var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "17",
        height: "16",
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M8.5 16C10.6217 16 12.6566 15.1571 14.1569 13.6569C15.6571 12.1566 16.5 10.1217 16.5 8C16.5 5.87827 15.6571 3.84344 14.1569 2.34315C12.6566 0.842855 10.6217 0 8.5 0C6.37827 0 4.34344 0.842855 2.84315 2.34315C1.34285 3.84344 0.5 5.87827 0.5 8C0.5 10.1217 1.34285 12.1566 2.84315 13.6569C4.34344 15.1571 6.37827 16 8.5 16ZM7.25 10.5H8V8.5H7.25C6.83437 8.5 6.5 8.16562 6.5 7.75C6.5 7.33437 6.83437 7 7.25 7H8.75C9.16562 7 9.5 7.33437 9.5 7.75V10.5H9.75C10.1656 10.5 10.5 10.8344 10.5 11.25C10.5 11.6656 10.1656 12 9.75 12H7.25C6.83437 12 6.5 11.6656 6.5 11.25C6.5 10.8344 6.83437 10.5 7.25 10.5ZM8.5 4C8.76522 4 9.01957 4.10536 9.20711 4.29289C9.39464 4.48043 9.5 4.73478 9.5 5C9.5 5.26522 9.39464 5.51957 9.20711 5.70711C9.01957 5.89464 8.76522 6 8.5 6C8.23478 6 7.98043 5.89464 7.79289 5.70711C7.60536 5.51957 7.5 5.26522 7.5 5C7.5 4.73478 7.60536 4.48043 7.79289 4.29289C7.98043 4.10536 8.23478 4 8.5 4Z",
          fill: "#717986",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }